module.exports = "<example-shell\n  exampleId=\"header-groups\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Header groups\"\n    [columns]=\"headerGroupColumns\"\n    [data]=\"orders\"\n    [pagination]=\"true\"\n    [paginationPerPage]=\"5\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// /storage/data/github/tests/angular-data-table-component/angular-4/src/app/examples/header-groups/header-groups.component.html
// module id = ../../../../../src/app/examples/header-groups/header-groups.component.html
// module chunks = main